<template>
  <a-modal
    :title="$t('synchronization.stop_warning')"
    :visible="isOpened"
    :ok-text="$t('common.stop')"
    :ok-button-props="{
      props: {
        type: 'danger',
        loading: stopRequest,
        disabled: !stopConfirmationValueIsValid
      }
    }"
    @ok="handleStopSync"
    @cancel="handleCancel"
  >
    <div class="popover-body__input">
      <a-input
        v-model="stopConfirmationValue"
        :placeholder="$t('common.enter_text')"
      />
    </div>
  </a-modal>
</template>

<script setup lang="ts">
import { message } from "ant-design-vue"
import { computed, ref } from "vue"

import i18n from "@/i18n"
import syncService from "@/services/syncService"

// Helper Types/Variables
type Props = {
  isOpened: boolean
  syncUuid: string
}

const props = defineProps<Props>()
const emit = defineEmits(["close", "stop"])
// End Helper Types/Variables

// State
const stopRequest = ref(false)
const stopConfirmationValue = ref("")
// End State

// Computed
const stopConfirmationKey = computed(() => i18n.t("synchronization.stop_key"))
const stopConfirmationValueIsValid = computed(() => {
  return stopConfirmationValue.value.trim() === stopConfirmationKey.value
})
// End Computed

// Methods
const handleCancel = () => {
  emit("close")
}
const handleStopSync = async () => {
  stopRequest.value = true

  try {
    await syncService.updateSynchronization({
      uuid: props.syncUuid,
      data: { is_active: false }
    })

    emit("close")
    emit("stop")
  } catch (error) {
    message.error(i18n.t("synchronization.sync_not_updated") as string)
  } finally {
    stopRequest.value = false
  }
}
// End Methods
</script>
